"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformModelTransferApi = void 0;
const __1 = require("..");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Operations for creating, revoking, accepting, denying, model ownership transfer notifications.
 */
class SdPlatformModelTransferApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "model_transfers";
    }
    /**
     * Get all model transfer requests for models currently owned by the authenticated user.
     * @returns
     */
    getModelTransferRequests() {
        return super.__action(__1.RequestId.ModelTransferRequestList, ResourcesApi_1.Action.Get, "", {});
    }
    /**
     * Creates a model transfer request. The calling user must have permission "update_owner" for the model.
     * In case the receiving user immediately accepts the transfer request, no notification will be returned.
     * @param model_id
     * @param body {@link SdPlatformRequestModelTransferCreate}
     * @returns
     */
    createModelTransferRequest(model_id, body) {
        return super.__action(__1.RequestId.ModelTransferRequestCreate, ResourcesApi_1.Action.Post, `${model_id}`, body);
    }
    /**
     * Deletes a model transfer request by model id. The calling user must have permission "update_owner" for the model.
     * @param model_id
     * @returns
     */
    deleteModelTransferRequest(model_id) {
        return super.__action(__1.RequestId.ModelTransferRequestDelete, ResourcesApi_1.Action.Delete, `${model_id}`, {});
    }
    /**
     * Get a model transfer request by model id. The calling user must have permission "update_owner" for the model.
     * The receiving user can see the model transfer request when querying notifications in general.
     * @param model_id
     * @returns
     */
    getModelTransferRequest(model_id) {
        return super.__action(__1.RequestId.ModelTransferRequestGet, ResourcesApi_1.Action.Get, `${model_id}`, {});
    }
    /**
     * Accept a model transfer request. This must be called by the receiving user.
     * @param model_id
     * @returns
     */
    acceptModelTransferRequest(model_id) {
        return super.__action(__1.RequestId.ModelTransferRequestAccept, ResourcesApi_1.Action.Post, `accept/${model_id}`, {});
    }
    /**
     * Deny the model transfer request. This must be called by the receiving user.
     * @param model_id
     * @returns
     */
    denyModelTransferRequest(model_id) {
        return super.__action(__1.RequestId.ModelTransferRequestDeny, ResourcesApi_1.Action.Post, `deny/${model_id}`, {});
    }
}
exports.SdPlatformModelTransferApi = SdPlatformModelTransferApi;
//# sourceMappingURL=SdPlatformModelTransferApi.js.map